export default __webpack_public_path__ + "static/media/avatar_106.aa006694.png";